import TableContainer from "@mui/material/TableContainer";
import { Paper, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import BandsTable from "./table";
import { EditionBand } from ".";
interface IBandTableProps {
  bands: EditionBand[];
  eventTimezone: string;
  groupBy?: "stage" | "announcement";
  showImageSizes?: boolean;
  onRemoveBooking?: (bookingId: string, bandName: string) => void;
  removingBookingId?: string | null;
}

const BandsTables = ({
  bands,
  eventTimezone,
  groupBy = "stage",
  showImageSizes = false,
  onRemoveBooking,
  removingBookingId,
}: IBandTableProps) => {
  const [groupedBands, setGroupedBands] = useState<Map<string, EditionBand[]>>(
    new Map<string, EditionBand[]>()
  );
  useEffect(() => {
    if (!bands) return;

    const groupingKey = groupBy === "announcement"
      ? (band: EditionBand) => (band.source && band.source.trim().length > 0 ? band.source : "Edition")
      : (band: EditionBand) => band?.stage?.name ?? "No Stage";

    const grouped: Map<string, EditionBand[]> = bands.reduce((prev, next) => {
      const key = groupingKey(next);
      const bands = prev.get(key) ?? [];

      prev.set(key, [...bands, next]);

      return prev;
    }, new Map());
    setGroupedBands(grouped);
  }, [bands, groupBy]);
  const keys = useMemo(() => {
    const groupKeys = Array.from(groupedBands.keys());
    if (groupBy === "announcement") {
      return groupKeys.sort((a, b) => a.localeCompare(b));
    }
    return groupKeys;
  }, [groupedBands, groupBy]);
  const getGroupTitle = (groupKey: string) => {
    if (groupBy === "announcement") {
      if (groupKey === "Edition") return "Edition";
      return `Announcement: ${groupKey}`;
    }
    return groupKey;
  };

  return (
    <>
      {keys.map((key) => {
        const bands = groupedBands.get(key);
        if (!bands) return null;
        return (
          <BandsTable
            key={key}
            bands={bands}
            eventTimezone={eventTimezone}
            getImageSize={showImageSizes}
            title={getGroupTitle(key)}
            onRemoveBooking={onRemoveBooking}
            removingBookingId={removingBookingId}
          />
        );
      })}
    </>
  );
};

export default BandsTables;
